<template>
  <v-card flat tile outlined class="pa-4" style="position: relative;">
    <div
      class="chart-actions"
      style="position: absolute; top: 16px; right: 16px;"
    >
      <slot name="actions" />
    </div>
    <div class="text-center">
      <div v-if="title" class="title font-weight-bold">{{ title }}</div>
      <div v-if="dateRange" class="body-2 grey--text">{{ dateRange }}</div>
    </div>
    <transition name="fade-fast" mode="out-in">
      <v-row
        v-if="loading"
        justify="center"
        align="center"
        key="loading-chart"
        style="height:150px;"
      >
        <v-col cols="6" class="py-10" style="max-width:200px;">
          <div class="body-2 font-italic text-center mb-2 grey--text"
            >Chart Loading</div
          >
          <v-progress-linear
            color="amber darken-2"
            indeterminate
            rounded
            height="4"
          />
        </v-col>
      </v-row>
      <div v-else-if="error">
        <h3 class="text-center font-italic grey--text pa-3">{{ error }}</h3>
      </div>
      <div v-else>
        <h2 v-if="subtitle">{{ subtitle }}</h2>
        <slot />
      </div>
    </transition>
  </v-card>
</template>

<script>
export default {
  name: 'ChartBase',
  props: {
    title: {
      type: String,
      default: null,
    },
    dateRange: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    error: {
      type: String,
      default: null,
    },
  },
  data() {
    return {}
  },
}
</script>
